import api from "./axios";

export async function submitReport(formData: FormData) {
  const response = await api.post("/reports", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function eraseReports(userEmail: string, recaptchaToken: string) {
  const response = await api.post<{ deleted: number }>("/reports/erase", {
    userEmail,
    recaptchaToken,
  });
  return response.data;
}
